export const toggleInputLoader = (id, color) => {
    let kLoaderE = document.querySelector(`#${id}`);
    let kLoaderContainerE;

    if (kLoaderE) {
        if (kLoaderE.classList.contains('k-btn-primary') || kLoaderE.classList.contains('k-btn-secondary')) {
            var appendedLoader = false;
            for (let index = 0; index < kLoaderE.children.length; index++) {
                const element = kLoaderE.children[index]
                if(element.classList.contains('k-btn-load')) {
                    appendedLoader = index;
                }
            }
            if (!appendedLoader) {
                let loader = `
                    <div class="k-btn-load">
                        <span class="k-btn-loading-dot"></span>
                        <span class="k-btn-loading-dot"></span>
                        <span class="k-btn-loading-dot"></span>
                        <span class="k-btn-loading-dot"></span>
                    </div>
                    `
                kLoaderE.innerHTML += loader
                appendedLoader = kLoaderE.children.length - 1
            }
            if (kLoaderE.classList.contains('k-btn-loader')) {
                kLoaderE.classList.remove('k-btn-loader')
                kLoaderE.children[appendedLoader].style.display = "none"
            } else {
                kLoaderE.classList.add('k-btn-loader')
                kLoaderE.children[appendedLoader].style.display = "block"
            }
        } else {
            kLoaderContainerE = kLoaderE.querySelector('.k-input-loader-container');
            if (kLoaderContainerE) {
                console.log(kLoaderContainerE)
                kLoaderContainerE.classList.toggle('k-display-loader');
        
                if(color == 'blue'){
                    kLoaderContainerE.classList.add('k-loader-blue');
                }else{
                    kLoaderContainerE.classList.remove('k-loader-blue');
                }
            }
        }
    }
}

export const toggleSpinner = (container, position = 'only', bgdColor = '#fff', size = '24') => {
    let containerChildren  = Array.from(container.children);
    let cssSelector        = '';

    const getClassSelector = () => {
        let classList = container.classList;
        classList.forEach(className => cssSelector += `.${className}`);
        return cssSelector;
    }

    cssSelector = container.id ? `#${container.id}` : getClassSelector();

    //create spinner
    let spinner = document.createElement('i');
    spinner.classList.add('k-spinner')
    spinner.innerHTML = `<span class="k-spinner-body"></span>`;

    //create styles
    let style = document.createElement('style');
    style.innerHTML = `${cssSelector} .k-spinner{ width:${size}px; height:${size}px; }
                       ${cssSelector} .k-spinner::after,
                       ${cssSelector} .k-spinner::before,
                       ${cssSelector} .k-spinner-body{ background-color:${bgdColor};}`
    spinner.append(style);


    if (container.classList.contains('k-spinner-loaded')){
        containerChildren.forEach(child => child.style.display = '');
        container.querySelector('.k-spinner').remove();
        container.classList.remove('k-spinner-loaded');
    } else {
        if (position == 'start'){
            containerChildren.forEach(child => {
                let tagName = child.tagName.toLowerCase();
                if (tagName == 'i' || tagName == 'img' || tagName == 'svg'){
                    child.style.display = 'none';
                }
            });
            container.prepend(spinner);
            container.classList.add('k-spinner-loaded');
        }

        else if (position == 'end'){
            containerChildren.forEach(child => {
                let tagName = child.tagName.toLowerCase();
                if (tagName == 'i' || tagName == 'img' || tagName == 'svg'){
                    child.style.display = 'none';
                }
            });
            container.append(spinner);
            container.classList.add('k-spinner-loaded');
        }

        else if (position == 'only'){
            containerChildren.forEach(child => child.style.display = 'none');
            container.prepend(spinner);
            container.classList.add('k-spinner-loaded');
        }
    }
}